module.exports = __webpack_public_path__ + "img/Pen-Edit.96c251d8.svg";